(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[803],{

/***/ "fMZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SearchGlass", function() { return SearchGlass; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var SearchGlass = function SearchGlass(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.601 12.817C20.601 14.899 19.816 16.804 18.332 18.327C16.898 19.797 14.942 20.607 12.824 20.607C10.747 20.607 8.844 19.82 7.324 18.333C4.305 15.31 4.303 10.363 7.318 7.306C8.785 5.837 10.741 5.028 12.824 5.028C14.902 5.028 16.804 5.814 18.325 7.302C19.793 8.737 20.601 10.696 20.601 12.817M26.693 25.285L20.408 18.989L20.6 18.739C23.577 14.861 23.198 9.333 19.718 5.881C17.863 4.023 15.402 3 12.791 3C10.179 3 7.719 4.022 5.865 5.88C2.045 9.705 2.045 15.93 5.865 19.755C7.719 21.612 10.179 22.635 12.791 22.635C14.974 22.635 17.017 21.945 18.701 20.64L18.95 20.447L25.27 26.708C25.465 26.903 25.732 27 26 27C26.267 27 26.534 26.903 26.728 26.71C27.104 26.332 27.088 25.68 26.693 25.285"
  }));
};

/***/ })

}]);